import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/imgcaptions/icon_fileXXXXL.svg'
import _imports_1 from '@/assets/sound/videoImg.png'
import _imports_2 from '@/assets/sound/play3.png'
import _imports_3 from '@/assets/sound/pause3.png'
import _imports_4 from '@/assets/aivoice/pic_kongyinpin.svg'


const _hoisted_1 = ["onClick"]
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "pieceOneSetBtn" }
const _hoisted_4 = {
  key: 0,
  class: "setBox"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onDblclick"]
const _hoisted_8 = {
  key: 0,
  class: "pieceOneTopInnerVideo"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 1,
  class: "pieceOneTopInnerImg"
}
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "pieceOneBtm" }
const _hoisted_14 = ["src"]
const _hoisted_15 = {
  key: 0,
  class: "noDataPage"
}
const _hoisted_16 = {
  key: 0,
  class: "pieceBoxmask"
}
const _hoisted_17 = { class: "piecedelBox" }
const _hoisted_18 = {
  key: 0,
  class: "pieceBoxmask"
}
const _hoisted_19 = { class: "piecedelBox" }
const _hoisted_20 = {
  key: 0,
  class: "pieceBoxmask"
}
const _hoisted_21 = { class: "piecedelPathBox" }

import { ref, onMounted, watch,getCurrentInstance,nextTick,onUnmounted} from 'vue'
// 引入删除模块
import delbox from '../commonPage/delPrompt.vue'
// 引入重命名模块
import reNamebox from '../commonPage/reNamePage.vue'
// 引入重命名模块
import rePathbox from '../commonPage/changePath.vue'
// 引入接口
import fileApi from '@/api/sound/fileManage.ts';
import {
    Search,
    Setting,
} from "@element-plus/icons-vue";
// 默认参数
const multiple=1

export default /*@__PURE__*/_defineComponent({
  __name: 'pieceList',
  props: {
    size: Number,//放大倍数
    list:String,
    justUse:Array,
    treeList:Array,
},
  emits: ['reListData'],
  setup(__props, { emit: __emit }) {

let { proxy } = getCurrentInstance();
const overIndex=ref(-1)//高亮Index

 //默认宽度
const initStyle={
    widthout:15.4,
    width:13,
    height:8,
    left: 2.5,
    top:0.2,
    topheight:1.6
}
const initmultiple=ref(1)//初始倍数
const amplify=ref(1) //放大倍数
const props = __props
const setIndex=ref(-1)//操作弹窗
const opendelShow=ref(false)//删除弹窗
const delText=ref('')//删除提示词
const openreNameShow=ref(false)//重命名
const openrePathShow=ref(false)//更改路径
const selData=ref()//选中数据
const urlListening=ref('')//试听地址
const dataList=ref([])
const audioRef=ref()
const playIndex=ref(-1)
const emit = __emit
// 放大倍数
watch(() => props.size, (n, o) =>{
    console.log('放大倍数'+n)
    amplify.value=(n/60)
    initmultiple.value=(multiple+amplify.value)
    console.log(initmultiple.value*initStyle.width)
    
})
watch(() => props.list,(n,o)=>{
    dataList.value=JSON.parse(n)
    audioRef.value?.pause()
})
onMounted(()=>{
    dataList.value=JSON.parse(props.list)
})
// 选择当前文件
const selThis=(data:any,index:number)=>{
    overIndex.value=index
    setIndex.value=index
    selData.value=data
    console.log(selData.value)
    
}

// 重命名
const reName=(data:any)=>{
    console.log('重命名')
    selData.value=data
    openreNameShow.value=true
    setIndex.value=-1
}
const reNameFun=(data:string)=>{
    console.log(data)
    fileApi.putRename(selData.value.fileId,data).then(res=>{
        console.log(res)
        if(res.code==200){
            openreNameShow.value=false
            emit('reListData')
            setIndex.value=-1
        }
    })
}

// 更改目录
const reCatalogue=()=>{
    console.log('更改目录')
    openrePathShow.value=true
    setIndex.value=-1
}
const updataTree=(data:any)=>{
    console.log(data[1])
    fileApi.putFile(selData.value.fileId,data[1]).then(res=>{
        console.log(res)
        emit('reListData')
        openrePathShow.value=false
        setIndex.value=-1
    })
}
// 下载
const downLoad=(data:any)=>{
    console.log('下载')
    const a = document.createElement("a");
    //   let url = baseUrl + binding.value // 若是不完整的url则需要拼接baseURL
    const url = proxy.getimgUrlVoice +data.url; // 完整的url则直接使用
    // 这里是将url转成blob地址，
    
    fetch(url)
        .then((res) => res.blob())
        .then((blob) => {
        // 将链接地址字符内容转变成blob地址
        a.href = URL.createObjectURL(blob);
        // console.log(a.href)
        a.download = data.filename; // 下载文件的名字
        // a.download = url.split('/')[url.split('/').length -1] //  // 下载文件的名字
        document.body.appendChild(a);
        a.click();
    });
}
// 删除
const delThis=()=>{
    // console.log('删除')
    delText.value="删除该项目，且永久不可恢复，确认删除？"
    opendelShow.value=true
}
const delFun=()=>{
    // console.log('删除回调')
    // console.log(selData.value)
    if(selData.value.folder=='1'){//删除问价夹
        fileApi.delFolder(selData.value.fileId).then(res=>{
            console.log(res)
            if(res.code==200){
                opendelShow.value=false
                emit('reListData')
                setIndex.value=-1
            }
        })
    }else{//删除文件
        fileApi.delFile(selData.value.fileId).then(res=>{
            console.log(res)
            if(res.code==200){
                opendelShow.value=false
                emit('reListData')
                setIndex.value=-1
            }
        })
    }
    
}
// 双击打开文件夹
const openFiled=(data:any)=>{
    console.log(data)
    setIndex.value=-1
    overIndex.value=-1
    emit('openFolder',JSON.stringify(data))
}
const toPlay =(data:any,index:number)=>{
    dataList.value.forEach((item:any )=> {
        item.isplay=false
    });
    playIndex.value=index
    dataList.value[index].isplay=true
    urlListening.value=data.url
    setTimeout(()=>{
        audioRef.value?.play()
    },100)
    
  
}
const updateCurrentTime = () => {
    dataList.value[playIndex.value].isplay=false
    audioRef.value?.pause()
}
// 暂停
const topause=(index:number)=>{
    dataList.value[playIndex.value].isplay=false
    audioRef.value?.pause()
}
onUnmounted(()=>{
    audioRef.value?.pause()
})

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: "pieceList",
    onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (setIndex.value=-1), ["stop"]))
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataList.value, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["pieceOne", overIndex.value==index?'selected':'']),
        key: index,
        onClick: _withModifiers(($event: any) => (selThis(item,index)), ["stop"]),
        style: _normalizeStyle({width:initmultiple.value*initStyle.widthout+'rem'})
      }, [
        _createElementVNode("div", {
          class: "pieceOneSet",
          onClick: _withModifiers(($event: any) => (selThis(item,index)), ["stop"])
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_icon, {
              color: "#fff",
              size: "20"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Setting))
              ]),
              _: 1
            })
          ]),
          (setIndex.value==index)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("span", {
                  class: "setBoxComm",
                  onClick: _withModifiers(($event: any) => (reName(item)), ["stop"])
                }, "重命名", 8, _hoisted_5),
                _createElementVNode("span", {
                  class: "setBoxComm",
                  onClick: _withModifiers(reCatalogue, ["stop"])
                }, "更改目录"),
                (item.folder=='0')
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: "setBoxComm",
                      onClick: _withModifiers(($event: any) => (downLoad(item)), ["stop"])
                    }, "下载", 8, _hoisted_6))
                  : _createCommentVNode("", true),
                _createElementVNode("span", {
                  class: "setBoxDel",
                  onClick: _withModifiers(delThis, ["stop"])
                }, "删除")
              ]))
            : _createCommentVNode("", true)
        ], 8, _hoisted_2),
        (item.folder=='1')
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["pieceOneTop", overIndex.value==index?'imgStyle':'']),
              onDblclick: _withModifiers(($event: any) => (openFiled(item)), ["stop"]),
              style: _normalizeStyle({width:initmultiple.value*initStyle.width+'rem',height:initmultiple.value*initStyle.height+'rem'})
            }, _cache[4] || (_cache[4] = [
              _createElementVNode("div", { class: "pieceOneTopInner" }, [
                _createElementVNode("img", {
                  src: _imports_0,
                  alt: ""
                })
              ], -1)
            ]), 46, _hoisted_7))
          : _createCommentVNode("", true),
        (item.folder=='0')
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(["pieceOneTop", overIndex.value==index?'imgStyle':'']),
              style: _normalizeStyle({width:initmultiple.value*initStyle.width+'rem',height:initmultiple.value*initStyle.height+'rem'})
            }, [
              (item.filetype.indexOf('audio')>-1 ||item.filetype.indexOf('application')>-1 )
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _cache[5] || (_cache[5] = _createElementVNode("img", {
                      src: _imports_1,
                      alt: "",
                      class: "videoImg"
                    }, null, -1)),
                    _withDirectives(_createElementVNode("img", {
                      src: _imports_2,
                      alt: "",
                      class: "videoBtn",
                      onClick: _withModifiers(($event: any) => (toPlay(item,index)), ["stop"])
                    }, null, 8, _hoisted_9), [
                      [_vShow, !item.isplay]
                    ]),
                    _withDirectives(_createElementVNode("img", {
                      src: _imports_3,
                      alt: "",
                      class: "videoBtn",
                      onClick: _withModifiers(($event: any) => (topause(index)), ["stop"])
                    }, null, 8, _hoisted_10), [
                      [_vShow, item.isplay]
                    ])
                  ]))
                : _createCommentVNode("", true),
              (item.filetype.indexOf('image')>-1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("img", {
                      src: _unref(proxy).getimgUrlVoice+item.url,
                      alt: ""
                    }, null, 8, _hoisted_12)
                  ]))
                : _createCommentVNode("", true)
            ], 6))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_13, _toDisplayString(item.filename), 1)
      ], 14, _hoisted_1))
    }), 128)),
    _createElementVNode("audio", {
      src: _unref(proxy).getimgUrlVoice + '/' + urlListening.value,
      controls: "",
      ref_key: "audioRef",
      ref: audioRef,
      onEnded: updateCurrentTime,
      style: {"display":"none"}
    }, null, 40, _hoisted_14),
    (dataList.value.length==0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, _cache[6] || (_cache[6] = [
          _createElementVNode("div", { class: "imgBox" }, [
            _createElementVNode("img", { src: _imports_4 }),
            _createElementVNode("div", null, "暂无数据")
          ], -1)
        ])))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      (opendelShow.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createVNode(delbox, {
                text: delText.value,
                onCloseThis: _cache[0] || (_cache[0] = ($event: any) => (opendelShow.value = false)),
                onRecognition: delFun
              }, null, 8, ["text"])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", null, [
      (openreNameShow.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createVNode(reNamebox, {
                name: selData.value.filename,
                onCloseThis: _cache[1] || (_cache[1] = ($event: any) => (openreNameShow.value = false)),
                onRecognition: reNameFun
              }, null, 8, ["name"])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", null, [
      (openrePathShow.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createVNode(rePathbox, {
                onCloseThis: _cache[2] || (_cache[2] = ($event: any) => (openrePathShow.value = false)),
                selId: selData.value.fileId,
                onUpparentId: updataTree
              }, null, 8, ["selId"])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})